import request from '@/utils/request'
const apiPath = '/cust_service/custServiceStaff'
import { downloadBlob } from '@/utils/download'
const custServiceStaffApi = {
  /**
   * 新增【客服人员】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【客服人员】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【客服人员】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee/listForMini', { params: query })
  },
  statusCount(query) {
    return request.get(apiPath + '/tee/getStatusCount', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【客服人员】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/tee/${id}`)
  },
  /**
   * 删除单个【客服人员】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  // 设置开启自动回复
  setIsAutoReply(data) {
    return request.put(apiPath + '/tee/setIsAutoReply', data)
  },
  // 设置开启新消息提醒
  setIsNewMsgRemind(data) {
    return request.put(apiPath + '/tee/setIsNewMsgRemind', data)
  },
  // 设置风控次数
  setRiskControl(data) {
    return request.put(apiPath + '/tee/setRiskControl', data)
  },
  // 设置状态· 批量 
  setStatusBatch(data) {
    return request.put(apiPath + '/tee/setStatusBatch', data)
  },
  // 设置工作状态 · 批量 
  setWorkStatusBatch(data) {
    return request.put(apiPath + '/tee/setWorkStatusBatch', data)
  },
}
export default custServiceStaffApi
